import { useHasEntitlement } from '~publish/contexts/AccountContext'

/**
 * Whether Notes offer mentions: the @ picker, the Mention teammate button, and
 * any copy that invites the user to pull in a teammate. Mentions are a team
 * feature, so this follows `teamsPanel`, which the server grants to Team and
 * Agency and legacy Business plans. Free and Essentials do not have it.
 */
export const useNoteMentionsEnabled = (): boolean =>
  useHasEntitlement('teamsPanel')
